import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import LinkButton from '../controls/LinkButton'

import * as AuthenticationActionCreators from '../../actions/authentication'

class LoginLogout extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onLogout: PropTypes.func,
  }

  static mapStateToProps(state) {
    return {
      auth: state.auth,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      actions: bindActionCreators(AuthenticationActionCreators, dispatch),
    }
  }

  static defaultProps = {
    onLogout: () => {},
  }

  handleLogoutClick = (e) => {
    this.props.actions.logout(e)
    this.props.onLogout()
  }

  render() {
    const {
      auth,
      actions,
      onLogout,
      ...props
    } = this.props
    if (auth.isAuthenticated) {
      return (
        <LinkButton color="inherit" onClick={this.handleLogoutClick} {...props}>Logout</LinkButton>
      )
    }

    return (
      <LinkButton color="inherit" to={{ pathname: '/login' }} {...props}>Login</LinkButton>
    )
  }
}

export default connect(LoginLogout.mapStateToProps, LoginLogout.mapDispatchToProps)(LoginLogout)
